<template>
  <span v-if="data.length === 0 || data[0].y === 0" class="height-400 d_flex"><b>No data to display</b></span>
  <highcharts :options="options.chart" ref="chart" v-else></highcharts>
</template>

<script>
import Highcharts from "highcharts";

export default {
  data() {
    return {
      options: {
        stats: {},
        chart: {
          chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie'
          },
          title: {
            text: this.title
          },
          lang: {
            noData: "No data to display"
          },
          tooltip: {
            pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
          },
          plotOptions: {
            pie: {
              colors: this.generateRandomColors(this.data.length),
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels: {
                enabled: true,
                format:'<b>{point.name}</b> : {point.y:f} ({point.percentage:.1f} %)',
                // '<b>{point.name}</b>: {point.y:.1f} : {point.percentage:.1f} %',
                style: {
                  color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
                }
              }
            }
          },
          series: [{
            name: this.bottomText,
            colorByPoint: true,
            data: this.data

          }],
        }
      },
    };
  },
  props: {
    data: Array,
    categories: Array,
    bottomText: String,
    title: String,
  },
  watch: {
    data: {
      handler(val) {
        this.options.chart.series[0].data = val
      },
      deep: true,
      immediate: true
    },
  },
  methods: {
    generateRandomColors(count) {
      const bootstrapColors = [
        '#007bff',
        '#28a745',
        '#dc3545',
        '#ffc107',
        '#17a2b8',
        '#343a40',
        '#666ee8',
        '#ff4961',
        '#299AFF',
        '#4F5D70',
        '#28dac6',
        '#ffe802',
        '#2c9aff',
        '#84D0FF',
        '#EDF1F4',
        '#6e6b7b',
        '#FDAC34'
      ];
      const shuffledColors = bootstrapColors.sort(() => 0.5 - Math.random());
      return shuffledColors.slice(0, count);
    }
  }
};
</script>

<style>
.height-400 {
  height: 400px;
}

.d_flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
